/**
 * Product Accordion Hide Utility
 * Hides accordion dropdowns that have no content
 */
class ProductAccordionHide {
  constructor() {
    this.init();
  }

  init() {
    // Run on DOM content loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.hideEmptyAccordions());
    } else {
      this.hideEmptyAccordions();
    }

    // Listen for product info updates (when variants change)
    document.addEventListener('product-info:loaded', () => this.hideEmptyAccordions());
  }

  hideEmptyAccordions() {
    const accordions = document.querySelectorAll('.product__accordion.accordion');
    
    accordions.forEach(accordion => {
      const contentElement = accordion.querySelector('.accordion__content');
      
      if (contentElement) {
        const hasContent = this.checkForContent(contentElement);
        
        if (!hasContent) {
          accordion.style.display = 'none';
          accordion.setAttribute('data-hidden-empty', 'true');
        } else {
          accordion.style.display = '';
          accordion.removeAttribute('data-hidden-empty');
        }
      }
    });
  }

  checkForContent(element) {
    // Get the text content and strip whitespace
    const textContent = element.textContent.trim();
    
    // Check if there's any meaningful text content
    if (textContent.length === 0) {
      return false;
    }

    // Check for common empty content patterns
    const emptyPatterns = [
      /^\s*$/,
      /^&nbsp;*$/,
      /^<br\s*\/?>*$/i,
      /^<p>\s*<\/p>$/i,
      /^<div>\s*<\/div>$/i
    ];

    // Check if content matches empty patterns
    for (const pattern of emptyPatterns) {
      if (pattern.test(textContent)) {
        return false;
      }
    }

    // Check for HTML content that might be empty
    const htmlContent = element.innerHTML.trim();
    if (htmlContent === '' || htmlContent === '<p></p>' || htmlContent === '<div></div>') {
      return false;
    }

    // Check for images or other non-text content
    const hasImages = element.querySelector('img');
    const hasOtherElements = element.querySelector('*:not(br):not(p):not(div)');
    
    if (hasImages || hasOtherElements) {
      return true;
    }

    return true;
  }

  // Method to manually trigger hiding (useful for dynamic content)
  refresh() {
    this.hideEmptyAccordions();
  }
}

// Initialize the utility
const productAccordionHide = new ProductAccordionHide();

// Export for use in other scripts if needed
window.ProductAccordionHide = productAccordionHide;
